(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[672],{

/***/ 18557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99535);
/* harmony import */ var _Layout_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34171);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(309);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMiddleware__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46098);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


var _excluded = ["children", "redirect"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var DefaultLayout = function DefaultLayout(_ref) {
  var children = _ref.children,
      redirect = _ref.redirect,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  (0,_hooks_useMiddleware__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(false, '/dashboard/invoices', redirect);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Layout_styles__WEBPACK_IMPORTED_MODULE_2__/* .DefaultLayoutGrid */ .Er, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Row */ .X2, {
        justify: "center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Column */ .sg, {
          cols: 12,
          md: 8,
          lg: 6,
          xl: 5,
          children: children
        })
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);

/***/ }),

/***/ 34171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ DefaultLayoutGrid; },
/* harmony export */   "G$": function() { return /* binding */ AsideLayoutSidebar; },
/* harmony export */   "Ku": function() { return /* binding */ LayoutMain; },
/* harmony export */   "T9": function() { return /* binding */ AsideLayoutContainer; },
/* harmony export */   "TN": function() { return /* binding */ LayoutLoadingContainer; },
/* harmony export */   "g9": function() { return /* binding */ AsideLayoutContent; },
/* harmony export */   "oQ": function() { return /* binding */ AsideLayoutSidebarContainer; },
/* harmony export */   "rn": function() { return /* binding */ AsideLayoutContentContainer; },
/* harmony export */   "vC": function() { return /* binding */ DashboardLayoutContainer; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99535);
/* harmony import */ var _config_config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56626);



var LayoutMain = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].main.withConfig */ .ZP.main.withConfig({
  displayName: "Layoutstyles__LayoutMain",
  componentId: "sc-mwnvy-0"
})(["", ""], {
  "height": "100%",
  "width": "100%"
});
var LayoutLoadingContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__LayoutLoadingContainer",
  componentId: "sc-mwnvy-1"
})(["", ""], {
  "display": "flex",
  "justifyContent": "center",
  "alignItems": "center",
  "width": "100%",
  "height": "100vh"
});
var DefaultLayoutGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_base__WEBPACK_IMPORTED_MODULE_0__/* .Grid */ .rj).withConfig({
  displayName: "Layoutstyles__DefaultLayoutGrid",
  componentId: "sc-mwnvy-2"
})(["", ""], {
  "display": "flex",
  "minHeight": "100vh",
  "flexDirection": "column",
  "justifyContent": "center",
  "alignItems": "center"
});
/*
 DASHBOARD LAYOUT STYLES
*/

var DashboardLayoutContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__DashboardLayoutContainer",
  componentId: "sc-mwnvy-3"
})(["", " max-width:90rem;"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem"
});
/*
 ASIDE LAYOUT STYLES
*/

var AsideLayoutContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContainer",
  componentId: "sc-mwnvy-4"
})(["", " grid-template-columns:", " auto"], {
  "display": "grid"
}, _config_config_json__WEBPACK_IMPORTED_MODULE_1__/* .theme.asideLayout.sidebarWidth */ .rS.SV.h);
var AsideLayoutSidebar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
  displayName: "Layoutstyles__AsideLayoutSidebar",
  componentId: "sc-mwnvy-5"
})(["", ""], {
  "display": "block",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))",
  "position": "relative",
  "maxHeight": "100vh"
});
var AsideLayoutSidebarContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutSidebarContainer",
  componentId: "sc-mwnvy-6"
})(["", " ", ""], {
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "height": "100%",
  "overflowY": "auto"
}, function (_ref) {
  var $disableScroll = _ref.$disableScroll;
  return $disableScroll ? {
    "overflowY": "hidden"
  } : {
    "overflowY": "auto"
  };
});
var AsideLayoutContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContentContainer",
  componentId: "sc-mwnvy-7"
})(["", " ", ""], {
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem",
  "maxHeight": "100vh",
  "overflowY": "auto"
}, function (_ref2) {
  var $disableScroll = _ref2.$disableScroll;
  return $disableScroll ? {
    "overflowY": "hidden"
  } : {
    "overflowY": "auto"
  };
});
var AsideLayoutContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContent",
  componentId: "sc-mwnvy-8"
})(["", " width:45.875rem;"], {
  "marginLeft": "auto",
  "marginRight": "auto"
});

/***/ }),

/***/ 309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/base/index.ts + 46 modules
var base = __webpack_require__(99535);
// EXTERNAL MODULE: ./components/layout/Layout.styles.tsx
var Layout_styles = __webpack_require__(34171);
// EXTERNAL MODULE: ./utils/Helper.ts + 6 modules
var Helper = __webpack_require__(6435);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
;// CONCATENATED MODULE: ./components/base/scroll-top-button/ScrollTopButton.styles.tsx

var ScrollTopButtonRoot = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ScrollTopButtonstyles__ScrollTopButtonRoot",
  componentId: "sc-g7p5q0-0"
})(["", ""], {
  "zIndex": "50",
  "marginRight": "0.5rem",
  "position": "fixed",
  "bottom": "1.5rem",
  "right": "1rem",
  "width": "3.5rem",
  "height": "3.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgba(14, 40, 190, var(--tw-bg-opacity))",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(131, 166, 234, var(--tw-bg-opacity))"
  },
  "display": "flex",
  "justifyContent": "center",
  "alignItems": "center"
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/base/scroll-top-button/ScrollTopButton.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MaximizeIcon = function MaximizeIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 14C3.55228 14 4 14.4477 4 15V20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H3C2.44772 22 2 21.5523 2 21V15C2 14.4477 2.44772 14 3 14Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929Z"
    })]
  }));
};

MaximizeIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#ffffff",
  xmlns: "http://www.w3.org/2000/svg"
};




var ScrollTopButton = function ScrollTopButton(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  var onClick = function onClick(event) {
    props === null || props === void 0 ? void 0 : props.onClick(event);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollTopButtonRoot, _objectSpread(_objectSpread({}, props), {}, {
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MaximizeIcon, {
      className: "fill-white"
    })
  }));
};

/* harmony default export */ var scroll_top_button_ScrollTopButton = (ScrollTopButton);
// EXTERNAL MODULE: ./config/config.json
var config = __webpack_require__(56626);
// EXTERNAL MODULE: ./hooks/invoice-upload/useInvoiceUploadContext.ts
var useInvoiceUploadContext = __webpack_require__(10459);
;// CONCATENATED MODULE: ./components/layout/Layout.tsx


function Layout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Layout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Layout_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Layout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var LoadingSpinIcon = function LoadingSpinIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Layout_objectSpread(Layout_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "primary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.4C6.69807 2.4 2.4 6.69807 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "secondary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8 1.2C10.8 0.537258 11.3373 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 11.3373 0.537258 10.8 1.2 10.8C1.86274 10.8 2.4 11.3373 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4C11.3373 2.4 10.8 1.86274 10.8 1.2Z",
      fill: "white"
    })]
  }));
};

LoadingSpinIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#BBC9DE",
  xmlns: "http://www.w3.org/2000/svg"
};








var Layout = function Layout(_ref) {
  var children = _ref.children,
      headers = _ref.headers,
      titleProp = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      loading = _ref.loading;
  var title = "".concat(titleProp, " | ").concat(config/* appName */.DJ);
  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();

  var _useInvoiceUploadCont = (0,useInvoiceUploadContext/* default */.Z)(),
      isFileDialogOpen = _useInvoiceUploadCont.isFileDialogOpen,
      setFileDialogOpen = _useInvoiceUploadCont.setFileDialogOpen;

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    document.body.style.setProperty('background-color', (0,Helper/* getColorFromAppState */.QV)({
      theme: theme,
      $color: backgroundColor
    }));
  }, [backgroundColor, theme]);

  var onClickScrollTopButton = function onClickScrollTopButton(event) {
    event.preventDefault();
    setFileDialogOpen(true);
  };

  var renderLoading = function renderLoading() {
    return loading && /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_styles/* LayoutLoadingContainer */.TN, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingSpinIcon, {
        className: "animate-spin fill-primary-300 w-24 h-24"
      })
    });
  };

  var renderContent = function renderContent() {
    if (loading) {
      return renderLoading();
    }

    return children;
  };

  var renderScrollTopButton = function renderScrollTopButton() {
    var isOnInvoicesPage = router.pathname === '/dashboard/invoices';

    if (!isFileDialogOpen && !loading && isOnInvoicesPage) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Row */.X2, {
        justify: "end",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(scroll_top_button_ScrollTopButton, {
            onClick: onClickScrollTopButton
          })
        })
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      }), keywords && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: keywords.join(',')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: title
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "shortcut icon",
        type: "image/jpg",
        href: "/favicon.ico"
      }), headers]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_styles/* LayoutMain */.Ku, {
      children: renderContent()
    }), renderScrollTopButton()]
  });
};

/* harmony default export */ var layout_Layout = (Layout);

/***/ }),

/***/ 46098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _auth_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var useMiddleware = function useMiddleware() {
  var onlyLogged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var redirectTo = arguments.length > 1 ? arguments[1] : undefined;
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      push = _useRouter.push;

  var _useCurrentUser = (0,_auth_auth__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentUser */ .xJ)(),
      isLogged = _useCurrentUser.isLogged,
      isReady = _useCurrentUser.isReady;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      allowed = _useState[0],
      setAllowed = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!enabled || !isReady) {
      return;
    }

    var disallow = !isLogged && onlyLogged || isLogged && !onlyLogged;
    setAllowed(!disallow);

    if (disallow && redirectTo) {
      push(redirectTo);
    }
  }, [isLogged, onlyLogged, redirectTo, push, isReady, enabled]);
  return {
    allowed: allowed
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMiddleware);

/***/ }),

/***/ 49532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ forgotten_password; }
});

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(41696);
// EXTERNAL MODULE: ./components/layout/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(18557);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./components/base/index.ts + 46 modules
var base = __webpack_require__(99535);
// EXTERNAL MODULE: ./auth/auth.ts + 2 modules
var auth = __webpack_require__(98541);
// EXTERNAL MODULE: ./utils/Helper.ts + 6 modules
var Helper = __webpack_require__(6435);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/validator/index.js
var validator = __webpack_require__(48966);
var validator_default = /*#__PURE__*/__webpack_require__.n(validator);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/app/forgotten-password/send-email-card/ForgottenPasswordSendEmailCard.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.9873 12.2212L16.4513 17.6782C16.5473 17.7736 16.6236 17.8871 16.6756 18.0121C16.7276 18.1372 16.7544 18.2713 16.7544 18.4067C16.7544 18.5421 16.7276 18.6762 16.6756 18.8012C16.6236 18.9262 16.5473 19.0397 16.4513 19.1352C16.2567 19.3272 15.9942 19.4349 15.7208 19.4349C15.4473 19.4349 15.1849 19.3272 14.9903 19.1352L8.80028 12.9522C8.61318 12.7646 8.50564 12.5121 8.50005 12.2472C8.49446 11.9823 8.59126 11.7255 8.77028 11.5302L14.9833 5.30317C15.1765 5.10943 15.4388 5.00038 15.7124 5C15.986 4.99963 16.2485 5.10796 16.4423 5.30117C16.636 5.49438 16.7451 5.75664 16.7455 6.03026C16.7458 6.30387 16.6375 6.56643 16.4443 6.76017L10.9873 12.2212Z"
    })
  }));
};

ArrowLeftIcon.defaultProps = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "#0E28BE",
  xmlns: "http://www.w3.org/2000/svg"
};

var ForgottenPasswordIllustration = function ForgottenPasswordIllustration(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M124.798 81.3005C124.798 83.9696 122.628 86.1374 119.947 86.1374C117.266 86.1374 115.096 83.9696 115.096 81.3005C115.096 78.6315 117.266 76.4637 119.947 76.4637C122.628 76.4637 124.798 78.6315 124.798 81.3005Z",
      stroke: "#E1331B",
      strokeWidth: "2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M126.749 163.503C126.749 167.515 123.487 170.771 119.46 170.771C115.432 170.771 112.171 167.515 112.171 163.503C112.171 159.49 115.432 156.234 119.46 156.234C123.487 156.234 126.749 159.49 126.749 163.503Z",
      stroke: "#E1331B",
      strokeWidth: "2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "29.7826",
      y: "6.92169",
      width: "88.6646",
      height: "160.431",
      rx: "8.5",
      fill: "#ECF4FF",
      stroke: "#0E28BE",
      strokeWidth: "3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "35.2826",
      y: "75.9036",
      width: "77.1739",
      height: "19.5181",
      rx: "4",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "35.2826",
      y: "100.843",
      width: "77.1739",
      height: "18.4337",
      rx: "4",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "118.525",
      cy: "24.8778",
      rx: "13.6522",
      ry: "13.6193",
      fill: "#080F3D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M116.549 28.6422V28.351C116.549 27.5461 116.616 26.9045 116.748 26.4263C116.886 25.9481 117.084 25.5646 117.345 25.2757C117.605 24.9822 117.923 24.7147 118.297 24.4732C118.595 24.2838 118.86 24.092 119.092 23.8979C119.329 23.699 119.516 23.486 119.653 23.2587C119.79 23.0314 119.859 22.7734 119.859 22.4845C119.859 22.2052 119.793 21.959 119.66 21.7459C119.528 21.5328 119.345 21.3695 119.113 21.2558C118.886 21.1375 118.633 21.0783 118.353 21.0783C118.074 21.0783 117.811 21.1422 117.565 21.2701C117.324 21.3979 117.125 21.5802 116.968 21.8169C116.817 22.0489 116.739 22.3307 116.734 22.6621H113.467C113.481 21.6678 113.711 20.8534 114.156 20.2189C114.606 19.5844 115.2 19.1157 115.939 18.8127C116.677 18.5049 117.492 18.351 118.382 18.351C119.357 18.351 120.224 18.5025 120.981 18.8056C121.744 19.1086 122.343 19.556 122.778 20.1479C123.214 20.7397 123.432 21.4642 123.432 22.3212C123.432 22.8846 123.337 23.3818 123.147 23.8127C122.958 24.2435 122.693 24.6247 122.352 24.9561C122.016 25.2828 121.62 25.5811 121.166 25.851C120.811 26.0594 120.515 26.2772 120.278 26.5044C120.046 26.7317 119.871 26.9921 119.753 27.2857C119.634 27.5745 119.575 27.9296 119.575 28.351V28.6422H116.549ZM118.119 33.3013C117.608 33.3013 117.17 33.1214 116.805 32.7615C116.445 32.4017 116.268 31.9661 116.272 31.4547C116.268 30.9528 116.445 30.5243 116.805 30.1692C117.17 29.8094 117.608 29.6294 118.119 29.6294C118.607 29.6294 119.035 29.8094 119.405 30.1692C119.774 30.5243 119.961 30.9528 119.966 31.4547C119.961 31.7956 119.871 32.1058 119.696 32.3851C119.525 32.6645 119.3 32.887 119.021 33.0527C118.746 33.2184 118.446 33.3013 118.119 33.3013Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M49.3141 113.475L49.4562 111.277L47.6153 112.509L46.8539 111.169L48.8369 110.203L46.8539 109.237L47.6153 107.896L49.4562 109.129L49.3141 106.93H50.8425L50.6948 109.129L52.5357 107.896L53.2971 109.237L51.3198 110.203L53.2971 111.169L52.5357 112.509L50.6948 111.277L50.8425 113.475H49.3141ZM58.3454 113.475L58.4874 111.277L56.6465 112.509L55.8851 111.169L57.8681 110.203L55.8851 109.237L56.6465 107.896L58.4874 109.129L58.3454 106.93H59.8738L59.7261 109.129L61.567 107.896L62.3283 109.237L60.3511 110.203L62.3283 111.169L61.567 112.509L59.7261 111.277L59.8738 113.475H58.3454ZM67.3766 113.475L67.5187 111.277L65.6778 112.509L64.9164 111.169L66.8994 110.203L64.9164 109.237L65.6778 107.896L67.5187 109.129L67.3766 106.93H68.905L68.7573 109.129L70.5982 107.896L71.3596 109.237L69.3823 110.203L71.3596 111.169L70.5982 112.509L68.7573 111.277L68.905 113.475H67.3766ZM76.4079 113.475L76.5499 111.277L74.709 112.509L73.9476 111.169L75.9306 110.203L73.9476 109.237L74.709 107.896L76.5499 109.129L76.4079 106.93H77.9363L77.7886 109.129L79.6295 107.896L80.3908 109.237L78.4136 110.203L80.3908 111.169L79.6295 112.509L77.7886 111.277L77.9363 113.475H76.4079ZM85.4391 113.475L85.5812 111.277L83.7403 112.509L82.9789 111.169L84.9619 110.203L82.9789 109.237L83.7403 107.896L85.5812 109.129L85.4391 106.93H86.9675L86.8198 109.129L88.6607 107.896L89.4221 109.237L87.4448 110.203L89.4221 111.169L88.6607 112.509L86.8198 111.277L86.9675 113.475H85.4391ZM94.4704 113.475L94.6124 111.277L92.7715 112.509L92.0101 111.169L93.9931 110.203L92.0101 109.237L92.7715 107.896L94.6124 109.129L94.4704 106.93H95.9988L95.8511 109.129L97.692 107.896L98.4533 109.237L96.4761 110.203L98.4533 111.169L97.692 112.509L95.8511 111.277L95.9988 113.475H94.4704Z",
      fill: "#E1331B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "40.7174",
      y: "83.494",
      width: "66.3043",
      height: "5.42169",
      rx: "1",
      fill: "#BBC9DE"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M74.1149 52.3515C75.1391 52.3515 75.9693 51.5233 75.9693 50.5016C75.9693 49.4799 75.1391 48.6516 74.1149 48.6516C73.0908 48.6516 72.2605 49.4799 72.2605 50.5016C72.2605 51.5233 73.0908 52.3515 74.1149 52.3515Z",
      fill: "#080F3D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M81.2595 43.4763V42.0576C81.2595 38.9933 80.52 34.9302 74.1148 34.9302C67.7097 34.9302 66.9702 38.9933 66.9702 42.0576V43.4763C63.7847 43.8735 62.738 45.4851 62.738 49.4461V51.557C62.738 56.2103 64.1601 57.629 68.8246 57.629H79.4051C84.0696 57.629 85.4917 56.2103 85.4917 51.557V49.4461C85.4917 45.4851 84.445 43.8735 81.2595 43.4763ZM74.1148 53.9291C72.2149 53.9291 70.6791 52.3855 70.6791 50.5015C70.6791 48.6062 72.2263 47.074 74.1148 47.074C76.0034 47.074 77.5506 48.6175 77.5506 50.5015C77.5506 52.3969 76.0148 53.9291 74.1148 53.9291ZM68.8246 43.3741C68.7336 43.3741 68.654 43.3741 68.563 43.3741V42.0576C68.563 38.7322 69.5072 36.5191 74.1148 36.5191C78.7225 36.5191 79.6667 38.7322 79.6667 42.0576V43.3855C79.5757 43.3855 79.4961 43.3855 79.4051 43.3855H68.8246V43.3741Z",
      fill: "#080F3D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M25.3323 59.8988C25.3323 62.5678 23.1627 64.7356 20.4814 64.7356C17.8 64.7356 15.6304 62.5678 15.6304 59.8988C15.6304 57.2297 17.8 55.062 20.4814 55.062C23.1627 55.062 25.3323 57.2297 25.3323 59.8988Z",
      stroke: "#E1331B",
      strokeWidth: "2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "30.2329",
      cy: "41.4155",
      rx: "2.92547",
      ry: "2.91842",
      fill: "#E1331B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "125.798",
      cy: "70.5996",
      rx: "2.92547",
      ry: "2.91842",
      fill: "#E1331B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "123.848",
      cy: "149.397",
      rx: "2.92547",
      ry: "2.91842",
      fill: "#E1331B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "122.873",
      cy: "62.8172",
      rx: "1.95031",
      ry: "1.94561",
      fill: "#E1331B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "110.196",
      cy: "173.717",
      rx: "1.95031",
      ry: "1.94561",
      fill: "#E1331B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "28.2826",
      cy: "147.451",
      rx: "13.6522",
      ry: "13.6193",
      fill: "#080F3D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.3073 151.216V150.925C26.3073 150.12 26.3736 149.478 26.5062 149C26.6435 148.522 26.8423 148.138 27.1027 147.849C27.3632 147.556 27.6804 147.288 28.0545 147.047C28.3527 146.857 28.6179 146.666 28.8499 146.471C29.0866 146.273 29.2737 146.06 29.411 145.832C29.5483 145.605 29.617 145.347 29.617 145.058C29.617 144.779 29.5507 144.533 29.4181 144.319C29.2855 144.106 29.1032 143.943 28.8712 143.829C28.6439 143.711 28.3906 143.652 28.1113 143.652C27.8319 143.652 27.5691 143.716 27.3229 143.844C27.0814 143.971 26.8826 144.154 26.7263 144.39C26.5748 144.622 26.4967 144.904 26.492 145.236H23.2249C23.2391 144.241 23.4688 143.427 23.9138 142.792C24.3636 142.158 24.9579 141.689 25.6965 141.386C26.4351 141.078 27.2495 140.925 28.1397 140.925C29.1151 140.925 29.9815 141.076 30.7391 141.379C31.5014 141.682 32.1004 142.13 32.536 142.721C32.9716 143.313 33.1894 144.038 33.1894 144.895C33.1894 145.458 33.0947 145.955 32.9053 146.386C32.7159 146.817 32.4508 147.198 32.1099 147.53C31.7737 147.856 31.3783 148.155 30.9238 148.425C30.5687 148.633 30.2727 148.851 30.036 149.078C29.804 149.305 29.6288 149.566 29.5104 149.859C29.392 150.148 29.3329 150.503 29.3329 150.925V151.216H26.3073ZM27.8769 155.875C27.3655 155.875 26.9276 155.695 26.563 155.335C26.2031 154.975 26.0256 154.54 26.0303 154.028C26.0256 153.526 26.2031 153.098 26.563 152.743C26.9276 152.383 27.3655 152.203 27.8769 152.203C28.3646 152.203 28.7931 152.383 29.1624 152.743C29.5317 153.098 29.7188 153.526 29.7235 154.028C29.7188 154.369 29.6288 154.679 29.4536 154.959C29.2831 155.238 29.0582 155.461 28.7789 155.626C28.5043 155.792 28.2036 155.875 27.8769 155.875Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.3",
      d: "M33.5 16V19.9107C33.5 21.575 35.4142 22.5112 36.7279 21.4894L46.8988 13.5787C48.402 12.4096 47.5752 10 45.6709 10H39.5C36.1863 10 33.5 12.6863 33.5 16Z",
      fill: "#6C94E1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.3",
      d: "M115.5 158L115.5 156.308C115.5 155.09 114.421 154.155 113.215 154.329L73.6583 160.02C71.201 160.374 71.4605 164 73.9431 164L109.5 164C112.814 164 115.5 161.314 115.5 158Z",
      fill: "#6C94E1"
    })]
  }));
};

ForgottenPasswordIllustration.defaultProps = {
  width: "151",
  height: "180",
  viewBox: "0 0 151 180",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};






var ForgottenPasswordSendEmailCard = function ForgottenPasswordSendEmailCard() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('forgottenPassword'),
      t = _useTranslation.t;

  var _useRouter = (0,router.useRouter)(),
      push = _useRouter.push;

  var _useForgotPassword = (0,auth/* useForgotPassword */.pO)(),
      forgotPassword = _useForgotPassword.forgotPassword,
      isLoading = _useForgotPassword.isLoading;

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(es/* object */.Ry({
      email: es/* string */.Z_().test('is-email', t('forgottenPasswordPage.form.email.validation.notValid'), function (value) {
        return validator_default().isEmail(value || '');
      }).required(t('forgottenPasswordPage.form.email.validation.required'))
    })),
    reValidateMode: 'onChange'
  }),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      errors = _useForm.formState.errors,
      setError = _useForm.setError;

  var getFieldError = function getFieldError(path) {
    var _errors$path;

    return (_errors$path = errors[path]) === null || _errors$path === void 0 ? void 0 : _errors$path.message;
  };

  var submit = function submit(data) {
    return forgotPassword(data).then(function () {
      return push('/forgotten-password/sent-email');
    }).catch(function (error) {
      return (0,Helper/* handleFormErrorsFromAxios */.LR)(error, setError);
    });
  };

  var renderTitle = function renderTitle() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledH, {
      children: t('forgottenPasswordPage.title')
    });
  };

  var renderHeader = function renderHeader() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ForgottenPasswordIllustration, {});
  };

  var renderDescription = function renderDescription() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledP, {
      children: t('forgottenPasswordPage.description')
    });
  };

  var renderFooter = function renderFooter() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/",
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Button */.zx, {
        as: "a",
        variant: "text",
        underlineText: true,
        leftIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowLeftIcon, {}),
        children: t('forgottenPasswordPage.backToLoginButtonLabel')
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(base/* CenteredFormCard */.TY, {
    onSubmit: handleSubmit(submit),
    submitLabel: t('forgottenPasswordPage.form.submit'),
    title: renderTitle(),
    header: renderHeader(),
    footer: renderFooter(),
    description: renderDescription(),
    loading: isLoading,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Grid */.rj, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Row */.X2, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('forgottenPasswordPage.form.email.label'),
            type: "email",
            invalidMessage: getFieldError('email')
          }, register('email')))
        })
      })
    })
  });
};

/* harmony default export */ var send_email_card_ForgottenPasswordSendEmailCard = (ForgottenPasswordSendEmailCard);

var _StyledH = (0,styled_components_browser_esm/* default */.ZP)("h1").withConfig({
  displayName: "ForgottenPasswordSendEmailCard___StyledH",
  componentId: "sc-pbek0b-0"
})({
  "fontSize": "2.5rem",
  "lineHeight": "3.026rem",
  "--tw-text-opacity": "1",
  "color": "rgba(8, 15, 61, var(--tw-text-opacity))"
});

var _StyledP = (0,styled_components_browser_esm/* default */.ZP)("p").withConfig({
  displayName: "ForgottenPasswordSendEmailCard___StyledP",
  componentId: "sc-pbek0b-1"
})({
  "fontSize": "1rem",
  "lineHeight": "1.21rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgba(8, 15, 61, var(--tw-text-opacity))"
});
;// CONCATENATED MODULE: ./pages/forgotten-password/index.tsx





var ForgottenPasswordPage = function ForgottenPasswordPage() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('forgottenPassword'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
    title: t('forgottenPasswordPage.title'),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(send_email_card_ForgottenPasswordSendEmailCard, {})
  });
};

var __N_SSP = true;
/* harmony default export */ var forgotten_password = (ForgottenPasswordPage);

/***/ }),

/***/ 77979:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgotten-password",
      function () {
        return __webpack_require__(49532);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [535,491,966,774,888,179], function() { return __webpack_exec__(77979); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);